<template>
  <div class="container page profile-detail-page">
    <div class="header">
        <van-nav-bar :title="this.$route.query.serial" class="nav-bar">
          <template #left>
            <button class="nav-back" type="button" aria-label="Back" @click="back()">
              <van-icon name="arrow-left" />
            </button>
          </template>
        </van-nav-bar>
    </div>

    <div class="banner">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" @change="onSwipeChange">
        <van-swipe-item>
          <img class="banner_img" :src="this.$route.query.imgUrl" :alt="`${this.$route.query.serial || 'Member'} profile photo 1`">
        </van-swipe-item>
        <van-swipe-item>
          <img class="banner_img" :src="this.$route.query.detail1" :alt="`${this.$route.query.serial || 'Member'} profile photo 2`">
        </van-swipe-item>
        <van-swipe-item>
          <img class="banner_img" :src="this.$route.query.detail2" :alt="`${this.$route.query.serial || 'Member'} profile photo 3`">
        </van-swipe-item>
      </van-swipe>
      <div class="swipe-indicator" aria-live="polite">{{ currentSwipe }}/3</div>
    </div>
    <div class="certification-buttons">
      <button class="cert-btn cert-btn1" type="button">
        <van-icon name="passed" />
        <span>Certification</span>
      </button>
      <button class="cert-btn cert-btn2" type="button">
        <van-icon name="video-o" />
        <span>Video authentication</span>
      </button>
    </div>
    <div class="detail-body">
      <div class="profile-heading">
        <div>
          <div class="profile-eyebrow">Victoria verified member</div>
          <h1 class="profile-title">{{ this.$route.query.serial }}</h1>
        </div>
        <div class="verified-badge" aria-label="Verified profile">
          <van-icon name="passed" />
        </div>
      </div>
      
      <div class="voting-info">
        <van-icon name="like-o" />
        <span class="voting-text">Voting Competition: {{ this.$route.query.like }}</span>
      </div>

      <div class="basic-info">
        <span class="info-chip">Height {{ this.$route.query.high }}cm</span>
        <span class="info-chip">Weight {{ this.$route.query.weight }}kg</span>
        <span class="info-chip">Round {{ this.$route.query.round }}</span>
      </div>

      <div class="service-section">
        <span class="service-text"><van-icon name="location-o" /> Serving the city Nevsehir</span>
        <button class="movie-btn" type="button" @click="toServiceOnline">
          <van-icon name="play-circle-o" />
          <span>My movie</span>
        </button>
      </div>

      <div class="summary-section">
        <div class="summary-title"><van-icon name="notes-o" /> Summary</div>
        <div class="summary-content">
          <p>Dear members! After verifying your membership card, you can meet these beauties!</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      currentSwipe: 1,
      notice:"Welcome to Victoria Dating Club",
      bannerSwiperOption: {
        direction: 'horizontal',
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          isableOnInteraction: false,
        },
        loop: true,
        speed: 500,
      }
    }
  },
  methods:{
    back(){
      return window.history.back();
    },
    onSwipeChange(index) {
      this.currentSwipe = index + 1;
    },
    toServiceOnline(){
      this.$router.push({path:'/ServiceOnline'});
    }
  },
  mounted () {

  },
  created() {

  }
}

</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.container .header{
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
}

.nav-bar{
  background-color: #fff;
}

::v-deep .van-nav-bar__title {
  color: #000;
  font-size: 0.48rem;
  font-weight: 500;
}

::v-deep .van-icon-arrow-left {
  color: #666 !important;
  font-size: 0.5rem !important;
}

.banner{
  margin-top: 1.22667rem;
  position: relative;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.banner_img {
  width: 100%;
  display: block;
}

.swipe-indicator {
  position: absolute;
  bottom: 3.2rem;
  right: 50%;
  transform: translateX(50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 0.08rem 0.26667rem;
  border-radius: 0.26667rem;
  font-size: 0.37333rem;
  z-index: 10;
}

.certification-buttons {
  bottom: 0.4rem;
  display: flex;
  justify-content: center;
  gap: 0.06667rem;
  width: 100%;
  background-color: #000;
  border-top-left-radius: 0.48rem;
  border-top-right-radius: 0.48rem;
  padding: 0.13333rem 0.5rem;
}

.cert-btn1 {
  flex: 1;
  height: 0.8rem;
  background: linear-gradient(135deg, #E7CBB0, #FBEFE2);
  color: #666;
  border: none;
  border-bottom-left-radius: 0.48rem;
  font-size: 0.34667rem;
  cursor: pointer;
  padding: 0 0.4rem;
}
.cert-btn2 {
  flex: 1;
  height: 0.8rem;
  background: linear-gradient(135deg, #E7CBB0, #FBEFE2);
  color: #666;
  border: none;
  border-top-right-radius: 0.48rem;
  font-size: 0.34667rem;
  cursor: pointer;
  padding: 0 0.4rem;
}

.detail-body {
  background-color: #fff;
  padding: 0.4rem;
  margin-top: 0.26667rem;
}

.profile-title {
  font-size: 0.53333rem;
  font-weight: bold;
  color: #000;
  margin-bottom: 0.26667rem;
}

.voting-info {
  margin-bottom: 0.4rem;
}

.voting-text {
  color: #e91e63;
  font-size: 0.37333rem;
  font-weight: 500;
}

.basic-info {
  margin-bottom: 0.4rem;
}

.basic-info span {
  color: #000;
  font-size: 0.37333rem;
  line-height: 1.6;
}

.service-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.53333rem;
}

.service-text {
  color: #000;
  font-size: 0.37333rem;
}

.movie-btn {
  background: linear-gradient(135deg, #9c27b0, #ba68c8);
  color: #fff;
  border: none;
  padding: 0.16rem 0.53333rem;
  border-radius: 0.32rem;
  font-size: 0.34667rem;
  cursor: pointer;
}

.summary-section {
  margin-top: 0.53333rem;
}

.summary-title {
  font-size: 0.42667rem;
  font-weight: bold;
  color: #000;
  margin-bottom: 0.26667rem;
}

.summary-content {
  color: #333;
  font-size: 0.37333rem;
  line-height: 1.6;
}

.summary-content p {
  margin: 0;
  color: #333;
}

/* Victoria Dating Club UI2 */
.profile-detail-page {
  min-height: 100vh;
  padding-bottom: max(0.56rem, env(safe-area-inset-bottom));
  background: transparent;
  color: var(--victoria-text);
}

.profile-detail-page .header {
  position: sticky;
  top: 0;
  z-index: 20;
  width: 100%;
}

.profile-detail-page .nav-bar {
  background: rgba(12, 10, 13, 0.86);
}

.profile-detail-page .nav-back {
  display: inline-flex;
  width: 0.88rem;
  height: 0.88rem;
  margin-left: -0.2rem;
  align-items: center;
  justify-content: center;
  color: var(--victoria-text);
  background: transparent;
  border: 0;
  border-radius: 50%;
}

.profile-detail-page .nav-back:focus-visible,
.profile-detail-page button:focus-visible {
  outline: 2px solid var(--victoria-light-rose);
  outline-offset: 2px;
}

.profile-detail-page .banner {
  width: calc(100% - 0.64rem);
  margin: 0.28rem auto 0;
  overflow: hidden;
  background: #080609;
  border: 1px solid var(--victoria-border);
  border-radius: 0.5rem 0.5rem 0.18rem 0.18rem;
  box-shadow: var(--victoria-shadow);
}

.profile-detail-page .my-swipe,
.profile-detail-page .banner_img {
  width: 100%;
  aspect-ratio: 0.84;
}

.profile-detail-page .banner_img {
  display: block;
  object-fit: cover;
  object-position: center top;
}

.profile-detail-page .swipe-indicator {
  bottom: 0.28rem;
  right: 50%;
  transform: translateX(50%);
  min-width: 1.08rem;
  padding: 0.08rem 0.22rem;
  color: var(--victoria-text);
  text-align: center;
  background: rgba(10, 8, 11, 0.72);
  border: 1px solid var(--victoria-divider);
  border-radius: 999px;
  backdrop-filter: blur(8px);
}

.profile-detail-page .certification-buttons {
  width: calc(100% - 0.64rem);
  margin: -0.02rem auto 0;
  gap: 1px;
  padding: 0.14rem;
  background: rgba(16, 13, 17, 0.94);
  border-right: 1px solid var(--victoria-border);
  border-bottom: 1px solid var(--victoria-border);
  border-left: 1px solid var(--victoria-border);
  border-radius: 0 0 0.48rem 0.48rem;
}

.profile-detail-page .cert-btn {
  display: inline-flex;
  min-width: 0;
  height: 0.92rem;
  padding: 0 0.16rem;
  gap: 0.12rem;
  align-items: center;
  justify-content: center;
  color: var(--victoria-light-rose);
  font-size: 0.3rem;
  background: rgba(231, 160, 174, 0.11);
  border: 1px solid rgba(231, 160, 174, 0.2);
}

.profile-detail-page .cert-btn1 {
  border-radius: 0.34rem 0.08rem 0.08rem 0.34rem;
}

.profile-detail-page .cert-btn2 {
  border-radius: 0.08rem 0.34rem 0.34rem 0.08rem;
}

.profile-detail-page .cert-btn .van-icon {
  flex: 0 0 auto;
  font-size: 0.4rem;
  color: var(--victoria-primary);
}

.profile-detail-page .detail-body {
  width: calc(100% - 0.64rem);
  margin: 0.34rem auto 0;
  padding: 0.48rem 0.42rem;
  color: var(--victoria-text);
  background: var(--victoria-surface);
  border: 1px solid var(--victoria-divider);
  border-radius: 0.46rem;
  box-shadow: var(--victoria-shadow);
  backdrop-filter: blur(14px);
}

.profile-detail-page .profile-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.3rem;
  margin-bottom: 0.32rem;
}

.profile-detail-page .profile-eyebrow {
  margin-bottom: 0.08rem;
  color: var(--victoria-text-muted);
  font-size: 0.27rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.profile-detail-page .profile-title {
  margin: 0;
  color: var(--victoria-text);
  font-family: var(--victoria-font-ui);
  font-size: 0.64rem;
  line-height: 1.1;
}

.profile-detail-page .verified-badge {
  display: inline-flex;
  width: 0.82rem;
  height: 0.82rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  color: #2a171d;
  font-size: 0.46rem;
  background: var(--victoria-action);
  border-radius: 50%;
  box-shadow: 0 0.14rem 0.4rem rgba(207, 127, 145, 0.26);
}

.profile-detail-page .voting-info {
  display: inline-flex;
  margin-bottom: 0.34rem;
  padding: 0.16rem 0.24rem;
  gap: 0.12rem;
  align-items: center;
  color: var(--victoria-light-rose);
  background: rgba(168, 107, 121, 0.18);
  border: 1px solid rgba(231, 160, 174, 0.18);
  border-radius: 999px;
}

.profile-detail-page .voting-text {
  color: inherit;
  font-size: 0.32rem;
}

.profile-detail-page .basic-info {
  display: flex;
  margin-bottom: 0.38rem;
  gap: 0.16rem;
  flex-wrap: wrap;
}

.profile-detail-page .basic-info .info-chip {
  padding: 0.14rem 0.22rem;
  color: var(--victoria-text);
  font-size: 0.3rem;
  line-height: 1.4;
  background: rgba(10, 8, 11, 0.52);
  border: 1px solid var(--victoria-divider);
  border-radius: 999px;
}

.profile-detail-page .service-section {
  margin: 0;
  padding: 0.34rem 0;
  gap: 0.3rem;
  border-top: 1px solid var(--victoria-divider);
  border-bottom: 1px solid var(--victoria-divider);
}

.profile-detail-page .service-text {
  display: inline-flex;
  gap: 0.1rem;
  align-items: center;
  color: var(--victoria-text-muted);
  font-size: 0.31rem;
  line-height: 1.45;
}

.profile-detail-page .service-text .van-icon {
  color: var(--victoria-primary);
  font-size: 0.4rem;
}

.profile-detail-page .movie-btn {
  display: inline-flex;
  min-width: 2.42rem;
  min-height: 0.9rem;
  padding: 0.14rem 0.28rem;
  gap: 0.12rem;
  align-items: center;
  justify-content: center;
  color: #29191e;
  font-weight: 700;
  background: var(--victoria-action);
  border: 0;
  border-radius: 999px;
  box-shadow: 0 0.16rem 0.42rem rgba(207, 127, 145, 0.24);
}

.profile-detail-page .summary-section {
  margin-top: 0.42rem;
}

.profile-detail-page .summary-title {
  display: flex;
  gap: 0.14rem;
  align-items: center;
  color: var(--victoria-text);
  font-size: 0.4rem;
}

.profile-detail-page .summary-title .van-icon {
  color: var(--victoria-primary);
}

.profile-detail-page .summary-content,
.profile-detail-page .summary-content p {
  color: var(--victoria-text-muted);
  font-size: 0.33rem;
  line-height: 1.75;
}

@media (max-width: 340px) {
  .profile-detail-page .cert-btn {
    font-size: 0.27rem;
  }

  .profile-detail-page .service-section {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
